export default "/images/InfoInCircle.png?ce7271322191d622ae42b87c2f400b04";